/**
 * Variant A — a slim bar at the bottom of the sidebar (above the user block),
 * expanding inline for incoming/active/dialpad/disposition. Lives inside the
 * dark <aside> as a normal flex child, so it never overlaps page content and
 * never breaks the overflow-hidden <main>.
 */

import clsx from 'clsx';
import { useSoftphone, SoftphoneBody } from '../DockedSoftphone';

export function SidebarPhoneDock() {
  const phone = useSoftphone();
  const expanded = phone.mode !== 'minimized';

  return (
    <div className="px-3 pb-2">
      {phone.recoveredToast && (
        <div className="mb-2 px-3 py-2 bg-amber-100 border border-amber-300 text-amber-900 rounded-md text-xs">
          {phone.recoveredToast}
        </div>
      )}
      <div
        className={clsx(
          'rounded-lg bg-white shadow-lg border border-slate-200 overflow-hidden',
          expanded && 'ring-1 ring-indigo-300',
        )}
      >
        <SoftphoneBody phone={phone} />
      </div>
    </div>
  );
}
